<template>
  <div class="page_wrap">
    <div class="page_flex">
        <div class="flex_left">
            <div class="page_tex">
                <div>关于</div>
                <div>Front<span style="color: #E2BF6B;">seat</span></div>
            </div>
            <div><img class="page_advantage_img" src="../assets/pinpai2.png" /></div>
            <div class="page_img_w"><img class="page_advantage_img2" src="../assets/pinpai2.png" /></div>
        </div>
        <div class="flex_right">
            <div class="page_right"><img class="page_right_img" src="../assets/pinpai3.png" /></div>
            <div style="display: flex;">
                <div><img class="page_right_img2" src="../assets/pinpai4.png" /></div>
                <div>
                    <div><img class="page_right_img3" src="../assets/pinpai1.png" /></div>
                    <div><img class="page_right_img3" src="../assets/pinpai2.png" /></div>
                </div>
            </div>
        </div>
    </div>
    <div class="page_zd">
       <div class="page_zd_a">合作门店加入</div>
       <div class="page_zd_b">合作门店加入宣传/合作门店加入宣传/合作合作门店加入宣传/合作门店加入宣传/合作合作门店加入宣传/合作门店加入宣传/合作合作门店加入宣传/合作门店加入宣传/合作合作门店加入宣传/合作门店加入宣传/合作合作门店加入宣传/合作门店加入宣传/合作</div>
       <div class="page_bg"></div>
       <div class="page_bg_flex">
        <div class="page_bg_2"></div>
        <div class="page_bg_2"></div>
       </div>
    </div>
    <div class="page_zd">
       <div class="page_zd_a">行业合作伙伴</div>
       <div class="page_zd_b">行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业</div>
      <div class="page_zd_x">
       <div class="page_flex_zd">
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai2.png" />
       </div>
    </div>
    </div>
    <div class="page_zd">
       <div class="page_zd_a">ERP合作伙伴</div>
       <div class="page_zd_b">行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业行业宣传语/行业宣传语/行业宣传语/行业</div>
      <div class="page_zd_x">
       <div class="page_flex_zd">
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
            <img class="page_flex_zd_bg" src="../assets/pinpai4.png" />
       </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.page_wrap{
  padding:5.1rem 5rem 6.875rem 5rem;
}
.page_flex{
    display: flex;
    justify-content: center;
}
.flex_right{
    margin-left:1.125rem;
}
.flex_left{ 
    width: 25.75rem;
    margin-top: 6.875rem;
}

.page_advantage_img {
  width: 25.75rem;
  height: 16.75rem;
  object-fit: cover;
  /* z-index: 100; */
  margin-bottom: 1.125rem;
}
.page_advantage_img2{
    width: 22rem;
    height: 22rem;
    object-fit: cover;
}
.page_img_w{
    display: flex;
    justify-content: right;
}
.page_tex{
    font-size: 5.5rem;
    line-height: 7.7rem;
    color: #222;
    margin-bottom: 3.6rem;
}
.page_right{
    display: flex;
    justify-content: right;
}
.page_right_img{
    width: 37.68rem;
    height: 32.18rem;
    object-fit: cover;
    margin-bottom: 1.125rem;
}
.page_right_img2{
    width: 25.75rem;
    height: 32.4rem;
    object-fit: cover;
    margin-right: 1.125rem;
}
.page_right_img3{
    width: 26.25rem;
    height: 15.625rem;
    margin-bottom: 1.125rem;
    object-fit: cover;
}
.page_zd{
    margin-top: 5rem;
}
.page_zd_a{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 5rem ;
    font-size: 3.1rem;
    color: #131316;
}
.page_zd_b{
    color: #222222;
    font-size: 1.75rem;
    margin-bottom: 5rem;
}
.page_bg{
    background: #D8D8D8;
    width: 100%;
    height: 36.25rem;
}
.page_bg_flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page_bg_2{
    margin-top: 3.75rem;
    width:37.8rem;
    height: 36.25rem;
    background: #D8D8D8;
}
.page_zd_x{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.page_flex_zd{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    
}
.page_flex_zd_bg{
    width: 14.25rem;
    height: 10rem;
    object-fit: cover;
    margin-bottom: 2rem;
    /* margin-right: 2rem; */
}
</style>